module.exports = __webpack_public_path__ + "static/media/2025_hintergrund.901acd69.jpg";